import { useEffect, useState } from "react";

/**
 * useState, значення якого переживає розмонтування компонента:
 * тримається в sessionStorage у межах вкладки браузера.
 *
 * Потрібен, наприклад, для пошуку в списку апок: після збереження змін в окремій
 * апці користувача повертає на основний екран, компонент таблиці монтується
 * заново — і пошукове слово має відновитись, а не збитись.
 */
export function usePersistedState<T>(storageKey: string, defaultValue: T) {
  const [value, setValue] = useState<T>(() => {
    try {
      const raw = sessionStorage.getItem(storageKey);
      return raw === null ? defaultValue : (JSON.parse(raw) as T);
    } catch {
      // sessionStorage недоступний (приватний режим) або в ньому зіпсовані дані
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(value));
    } catch {
      // ігноруємо: збереження стану UI не критичне
    }
  }, [storageKey, value]);

  return [value, setValue] as const;
}
